import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import PropTypes from 'prop-types';
// IF YOU WANT TO SPEED UP PERFORMANCE, CHANGE ProgressiveImage
// TO LazyImage ONLY ISSUE IS UX DIDN'T LIKE THE ALWAYS SHOWING
// LOADING ANIMATION
import LazyImage from 'react-lazy-progressive-image';

import LoadingSpinner from './LoadingSpinner/LoadingSpinner';

var _ref = React.createElement(LoadingSpinner, null);

var Image = function Image(props) {
  return React.createElement(
    ProgressiveImage,
    {
      src: props.src,
      placeholder: '' // required prop
    },
    function (src, loading, isVisible) {
      return loading || !isVisible ? _ref : React.createElement('img', { className: props.className, src: src, alt: props.alt });
    }
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string
};

export default React.memo(Image);